import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ReportTrackingSchema = withDefaults({
  type: 'report-tracking',
  fields: [
    {
      kind: 'attribute',
      name: 'reportId',
    },
    {
      kind: 'attribute',
      name: 'personId',
    },
    {
      kind: 'attribute',
      name: 'reportViewActivity',
    },
    {
      kind: 'attribute',
      name: 'browserMeta',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
  ],
});

export default ReportTrackingSchema;
